__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "slidespiel-ce";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("./src/config", "1.0.0", () => (__webpack_require__.e(322).then(() => (() => (__webpack_require__(65322))))));
			register("./src/uiConfig", "1.0.0", () => (__webpack_require__.e(893).then(() => (() => (__webpack_require__(96893))))));
			register("mobx-react", "7.5.2", () => (Promise.all([__webpack_require__.e(240), __webpack_require__.e(759), __webpack_require__.e(538), __webpack_require__.e(544)]).then(() => (() => (__webpack_require__(74452))))));
			register("mobx", "6.6.1", () => (__webpack_require__.e(621).then(() => (() => (__webpack_require__(59621))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(73961))))));
			register("react-router-dom", "5.3.3", () => (Promise.all([__webpack_require__.e(188), __webpack_require__.e(759), __webpack_require__.e(137)]).then(() => (() => (__webpack_require__(94188))))));
			register("react", "16.14.0", () => (__webpack_require__.e(837).then(() => (() => (__webpack_require__(50837))))));
			register("react", "18.2.0", () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(89526))))));
			initExternal(32969);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};